import PropTypes from "prop-types";
import React, { useEffect } from "react";
import {
  courses,
  courseDetails,
  courseDetailsVersions,
  courseDetailsAssignments,
  courseDetailsExclusions,
  courseDetailsRecordings,
  courseDetailsSessions,
  courseDetailsSettings,
  courseSetPrereqs,
  courseVersion,
  courseVersionDetails,
  courseVersionHomework,
  courseBuilder,
  courseSession,
  courseSessionDetails,
  courseSessionHomework,
  courseSessionAttendance,
  courseScheduleSession,
  courseSessionEnrollEmployees,
  manage,
  courseDetailsManage,
  scheduleSessionManage
} from "../../routes/AdminRoutes";
import { Route } from "react-router-dom";
import { Courses } from "../../views";
import {
  CourseDetails,
  SetPrerequisites
} from "../../views/Content/Courses/CourseDetails";
import CourseVersion from "../../views/Content/Courses/CourseVersion/CourseVersion";
import { ManageInstructorsLocations } from "../../views/Content/Courses/ManageInstructorsLocations";
import CourseBuilder from "../../views/Content/Courses/CourseBuilder";
import CourseSession from "../../views/Content/Courses/CourseSession/CourseSession";
import ScheduleSession from "../../views/Content/Courses/ScheduleSession/ScheduleSession";
import usePermissions from "../../redux/selectors/usePermissions";
import { useDispatch } from "react-redux";
import { resetTableStatus } from "../../redux/actions/tablesActions";

export default function AdminContentCourses(props) {
  const { canManageContent } = usePermissions();
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(resetTableStatus("courses"));
    };
  }, []);

  return (
    <>
      <Route exact={canManageContent} path={courses} component={Courses} />
      {canManageContent && (
        <>
          <Route
            exact
            path={[
              courseDetails,
              courseDetailsVersions,
              courseDetailsAssignments,
              courseDetailsExclusions,
              courseDetailsRecordings,
              courseDetailsSessions,
              courseDetailsSettings
            ]}
            component={CourseDetails}
          />
          <Route path={courseSetPrereqs} component={SetPrerequisites} />
          <Route
            exact
            path={courseScheduleSession}
            component={ScheduleSession}
          />
          <Route
            exact
            path={[courseVersion, courseVersionDetails, courseVersionHomework]}
            component={CourseVersion}
          />
          <Route
            exact
            path={[
              courseSession,
              courseSessionDetails,
              courseSessionHomework,
              courseSessionAttendance,
              courseSessionEnrollEmployees
            ]}
            component={CourseSession}
          />
          <Route path={courseBuilder} component={CourseBuilder} />
          <Route
            path={[manage, courseDetailsManage, scheduleSessionManage]}
            component={ManageInstructorsLocations}
          />
        </>
      )}
    </>
  );
}

AdminContentCourses.propTypes = {
  match: PropTypes.any
};
